import { useGaugeChartFormatterContext } from './useGaugeChartFormatterContext.js';
import { useGaugeChartRangeMaxContext } from './useGaugeChartRangeMaxContext.js';
import { useGaugeChartRangeMinContext } from './useGaugeChartRangeMinContext.js';

export const useDefaultLabels = (value: number) => {
  const min = useGaugeChartRangeMinContext();
  const max = useGaugeChartRangeMaxContext();
  const { formatter, unit } = useGaugeChartFormatterContext();

  const defaultLabel = `${formatter(value, unit)} / ${formatter(max, unit)}`;
  const defaultMaxLabel = `${formatter(max, unit)}`;
  const defaultMinLabel = `${formatter(min, unit)}`;
  const defaultValueLabel = `${formatter(value, unit)}`;

  return {
    defaultLabel,
    defaultMaxLabel,
    defaultMinLabel,
    defaultValueLabel,
  };
};
